<template>
  <div :class="$style.masonry" aria-hidden="true">
    <div
      v-for="(height, index) in heights"
      :key="`skeleton-${index}`"
      :class="$style.card"
      :style="{ minHeight: `${height}px` }"
    >
      <div :class="[$style.line, $style.lineShort]"></div>
      <div :class="$style.line"></div>
      <div :class="$style.line"></div>
      <div :class="[$style.line, $style.lineMedium]"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeTestimonialsSkeleton',

  data() {
    return {
      heights: [180, 240, 160, 220, 200, 260, 170, 230, 190, 210, 250, 175],
    }
  },
}
</script>

<style lang="scss" module>
.masonry {
  column-count: 1;
  column-gap: 16px;

  @include min-screen($mq-small) {
    column-count: 2;
  }

  @include min-screen($mq-large) {
    column-count: 3;
  }

  @include min-screen($mq-full) {
    column-count: 4;
  }
}

.card {
  break-inside: avoid;
  page-break-inside: avoid;
  display: inline-block;
  width: 100%;
  margin: 0 0 16px;
  background-color: $color-white;
  border-radius: 6px;
  box-shadow: 0 0 5px 0 $color-box-shadow;
  padding: 18px;
  vertical-align: top;
  box-sizing: border-box;
}

.line {
  height: 12px;
  margin-bottom: 10px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    $color-brand-sand-bg 0%,
    $color-brand-sand-bg-light 50%,
    $color-brand-sand-bg 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}

.lineShort {
  width: 42%;
  margin-bottom: 18px;
}

.lineMedium {
  width: 68%;
  margin-bottom: 0;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}
</style>
